<!-- Copyright (c) 20118 Cigent Technology Inc. All Rights Reserved. -->

<div class="progress-cont">
  <div class="progress" [style.width]="progress + '%'">
  </div>
</div>
